var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"bc-lp-language-switcher",attrs:{"type":"button"},on:{"click":_vm.switchLanguage}},[_vm._v(" "+_vm._s(_vm.otherLanguage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }